import api from '@/api/fetch'
import type { Catalogs } from '@/types'

export async function getCatalogs() {
  return api.get<Catalogs>('/pos/catalogs').then(res => res.data)
}
